type Props = { size?: 'sm' | 'md' | 'lg' };

const SIZE_CLASS: Record<NonNullable<Props['size']>, string> = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-9 h-9',
};

export function Spinner({ size = 'md' }: Readonly<Props>) {
  return (
    <output
      className={`inline-block rounded-full border-2 border-[var(--color-border)] border-t-[var(--color-primary)] animate-spin ${SIZE_CLASS[size]}`}
      aria-label="Loading"
    />
  );
}
